import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-modal-ia-not-approved-rules',
  templateUrl: './modal-ia-not-approved-rules.page.html',
  styleUrls: ['./modal-ia-not-approved-rules.page.scss'],
})
export class ModalIaNotApprovedRulesPage implements OnInit {

  @Input() activeReason: any;

  constructor(public modalCtrl: ModalController) { }

  ngOnInit() {
  }

  closeModal() {
    this.modalCtrl.dismiss();
  }

}
